import React from 'react'
import { COLORS } from 'app/constants'
import { CButton } from '../Common'

const AddButton = ({ title, onClick }) => {
	return (
		<CButton
			onClick={onClick}
			title={title}
			style={{
				whiteSpace: 'nowrap',
				background: COLORS.darkRed,
				padding: 10,
				color: COLORS.white,
			}}
		/>
	)
}
export const Addbutton = React.memo(AddButton)
